import { useSearch } from '@tanstack/react-router';

import { defaultMeta } from '@/constants/defaultMeta';
import { sortBy } from '@/lib/sortBy';
import { useQuery } from '@/react-query/hooks/useQuery/useQuery';
import { locationQueries } from '@/services/locations/locations.queries';

export const useLocationList = () => {
  const { page, sort, fetch, q } = useSearch({ from: '/(app)/configuration-management/location/' });

  const { data, isLoading } = useQuery({
    ...locationQueries.list({ fetch: fetch ?? 5, row: page ?? 0, search: q ?? '' }),
    select: (res) => ({
      ...res,
      data: sortBy(res.data, sort),
    }),
  });

  return {
    locations: data?.data || [],
    pagination: data?.meta?.pagination ?? defaultMeta,
    loading: isLoading,
  };
};
